import { render } from "./GasInfo.vue?vue&type=template&id=524f6479"
import script from "./GasInfo.vue?vue&type=script&lang=js"
export * from "./GasInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__